import { render, staticRenderFns } from "./BuyersAgent.vue?vue&type=template&id=a76e34e0&scoped=true&"
import script from "./BuyersAgent.vue?vue&type=script&lang=ts&"
export * from "./BuyersAgent.vue?vue&type=script&lang=ts&"
import style0 from "./BuyersAgent.vue?vue&type=style&index=0&id=a76e34e0&scoped=true&lang=css&"
import style1 from "./BuyersAgent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76e34e0",
  null
  
)

export default component.exports